import API from './api';
import RecomputedService from './recomputed-data';

export default {
  getRecomputedMetrics(payload) {
    return RecomputedService.getRecomputedData(
      '/api/users/me/metrics/v2/recomputed',
      payload
    )
  },
  updateMetricsCustomizations(payload) {
    return API.put(
      '/api/users/me/metrics-customizations',
      payload
    );
  },
  getAllMetrics() {
    return API.get('/api/users/me/metrics/v2');
  },
  getSettings() {
    return API.get('/api/users/me/metrics/settings');
  },
  getFilters() {
    return API.get('/api/users/me/metrics/filters');
  },
  // getExcludedCustomers() {
  //   return API.get('/api/users/me/metrics/excluded-customers');
  // },
  updateSettings(payload) {
    return API.put(
      '/api/users/me/metrics/settings',
      payload,
    );
  },
  updateFilters(payload) {
    return API.put(
      '/api/users/me/metrics/filters',
      payload,
    );
  },
  // updateExcludedCustomers(payload) {
  //   return API.put(
  //     '/api/users/me/metrics/excluded-customers',
  //     payload,
  //   );
  // },
};
